import { render, staticRenderFns } from "./marketManage.vue?vue&type=template&id=83a69a88"
import script from "./marketManage.vue?vue&type=script&lang=js"
export * from "./marketManage.vue?vue&type=script&lang=js"
import style0 from "./marketManage.vue?vue&type=style&index=0&id=83a69a88&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports